import React from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import Badge from "./Badge";

const BadgeCard = ({ badge }) => {
  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <Badge badge={badge} />
      </Grid>

      <Grid item>
        <Typography>{badge.fileName}</Typography>
      </Grid>
    </Grid>
  );
};

export default BadgeCard;
